import { render, staticRenderFns } from "./ShadowBackground.vue?vue&type=template&id=38775ca0&scoped=true"
import script from "./ShadowBackground.vue?vue&type=script&lang=js"
export * from "./ShadowBackground.vue?vue&type=script&lang=js"
import style0 from "./ShadowBackground.vue?vue&type=style&index=0&id=38775ca0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38775ca0",
  null
  
)

export default component.exports